module.exports = __webpack_public_path__ + "img/Profile@2x.7b05765b.png";